"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapLoggedInLabel = void 0;
function mapLoggedInLabel(links, isLoggedIn) {
    return links === null || links === void 0 ? void 0 : links.map(function (link) {
        var _a;
        return ({
            label: (isLoggedIn && link.loggedInLabel) ? link.loggedInLabel : link.label,
            url: (isLoggedIn && link.loggedInLabelUrl) ? link.loggedInLabelUrl : link.url,
            subnav: (_a = link.subnav) === null || _a === void 0 ? void 0 : _a.map(function (sub) { return ({
                label: (isLoggedIn && sub.loggedInLabel) ? sub.loggedInLabel : sub.label,
                url: (isLoggedIn && sub.loggedInLabelUrl) ? sub.loggedInLabelUrl : sub.url
            }); })
        });
    });
}
exports.mapLoggedInLabel = mapLoggedInLabel;
